import '@/lib/errorReporter';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import '@/index.css';
import { HomePage } from '@/pages/HomePage';

// The page is prerendered to static HTML at build time (scripts/prerender.mjs),
// so we hydrate the existing markup instead of re-rendering from scratch. This
// reuses the server-rendered DOM rather than throwing it away and rebuilding it,
// which is much cheaper on mobile. The tree below must match src/entry-server.tsx.
hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} forcedTheme="dark">
        <HomePage />
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
